import { ElementType } from 'react';
import store from '.';
import * as actions from './actions';
import { LinkParams, ImageState } from './types';

export function addUserMessage(text, id) {
  store.dispatch(actions.addUserMessage(text, id));
}

export function addResponseMessage(text, id) {
  store.dispatch(actions.addResponseMessage(text, id));
}

export function addLinkSnippet(link, id) {
  store.dispatch(actions.addLinkSnippet(link, id));
}

export function toggleMsgLoader(payload) {
  store.dispatch(actions.toggleMsgLoader(payload));
}
export function renderHistoryComponent(component, props, showAvatar = false, id) {
  store.dispatch(actions.renderHistoryComponent(component, props, showAvatar, id));
}
export function renderCustomComponent(component, props, showAvatar = false, id) {
  store.dispatch(actions.renderCustomComponent(component, props, showAvatar, id));
}
export function renderMultipleComponent(component, props, showAvatar = false, id) {
  store.dispatch(actions.renderMultipleComponent(component, props, showAvatar, id));
}
export function toggleWidget() {
  store.dispatch(actions.toggleChat());
}

export function toggleInputDisabled() {
  store.dispatch(actions.toggleInputDisabled());
}

export function toggleSendDisabled(cond) {
  store.dispatch(actions.toggleSendDisabled(cond));
}

export function setWidgetConfig(data) {
  store.dispatch(actions.setWidgetConfig(data));
}

export function setLoadingMessages(cond) {
  store.dispatch(actions.setLoadingMessages(cond));
}

export function setIsChatFullScreen(cond) {
  store.dispatch(actions.setIsChatFullScreen(cond));
}

export function setSessionAvailable(cond) {
  store.dispatch(actions.setSessionAvailable(cond));
}

export function setSessionStarted(cond) {
  store.dispatch(actions.setSessionStarted(cond));
}

export function setShowSenderComponent(cond) {
  store.dispatch(actions.setShowSenderComponent(cond));
}

export function setRecentMessage(val) {
  store.dispatch(actions.setRecentMessage(val));
}

export function dropMessages() {
  store.dispatch(actions.dropMessages());
}

export function isWidgetOpened() {
  return store.getState().behavior.showChat;
}

export function setQuickButtons(buttons) {
  store.dispatch(actions.setQuickButtons(buttons));
}

export function deleteMessages(count, id) {
  store.dispatch(actions.deleteMessages(count, id));
}

export function deleteLastMessage() {
  store.dispatch(actions.deleteLastMessage());
}

export function markAllAsRead() {
  store.dispatch(actions.markAllMessagesRead());
}

export function setTotalMessageCount(count) {
  store.dispatch(actions.setTotalMessageCount(count));
}

export function setBadgeCount(count) {
  store.dispatch(actions.setBadgeCount(count));
}

export function openFullscreenPreview(payload) {
  store.dispatch(actions.openFullscreenPreview(payload));
}

export function closeFullscreenPreview() {
  store.dispatch(actions.closeFullscreenPreview());
}

export function resetMessages(value) {
  store.dispatch(actions.resetMessages(value));
}
